// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__AvdNx","image":"Header_image__2_SeK","name":"Header_name__2vUDo","info":"Header_info__22Q8Q","infoRow":"Header_infoRow__1Ezqe"};